<p class="text-bold mb-1">{{ sectionTitle }}</p>
<a
  shrdUicButton
  variant="navList"
  class="mt-0 mb-1"
  *ngFor="let link of links"
  [href]="link.url"
  [attr.tabindex]="disabled ? -1 : 0"
  shrdUtcAutoTarget
>
  <span>{{ link.title }}</span>
</a>
